import { useLocation } from 'react-router-dom';
import { B2B_ROUTES } from 'constants/routes';

// Was reimplemented independently in NavbarV2, and twice in SiderApp — a
// second matching path (trailing slash, alias, locale prefix) would have
// needed all three updated in lockstep or the header, mobile drawer footer,
// and mobile menu would silently disagree on whether this is the B2B
// landing page.
export default function useIsB2BLandingPage() {
  const { pathname } = useLocation();
  return pathname === B2B_ROUTES.TRAVEL_PARTNERS;
}
